<template>
  <div class="sidebar-wrapper">
    <div class="title">
      <div class="left">Hello!</div>
      <div class="right">
        <img class="icon" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/d4259068f6c9c49aea6f072d4830da3b.png" alt="">
        <span class="integral">积分</span>
        <span class="number">{{data.user_integral}}</span>
      </div>
    </div>
    <div class="name">{{data.user_name}}</div>
    <div class="sidebar-card card">
      <div class="sidebar-card-logo-wrapper">
        <img class="round" :src="data.school_logo || 'https://vanthink.oss-cn-qingdao.aliyuncs.com/fac45e130f3abe875d729e29e964ca21.png'" alt="">
        <img class="badge" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/93b815ef5d653744a850a4751c0271bc.png" alt="">
      </div>
      <div class="school-info">
        <div class="school-name">{{data.school_name}}</div>
        <div class="school-phone" v-if="data.school_enrollment_phone">
          <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/687c1d8c5273c4cacbd846d6c52220ce.png" alt="">
          <span>{{data.school_enrollment_phone}}</span>
        </div>
      </div>
      <div class="since">于{{data.school_settle_in_time}}入驻学校</div>
    </div>
    <div class="target-card card">
      <div v-if="!isHasTarget" @click="editTarget" class="no-target">
        <div class="no-target-describe">
          <i class="el-icon-circle-plus-outline"></i>
          <div>点击添加自己的小目标</div>
        </div>
      </div>
      <template v-else>
        <div class="target-card-title">
          <div class="left">目标</div>
          <div class="right">调整状态 迎接新知识！</div>
        </div>
        <div class="describe">{{text}}</div>
        <div class="countdown-wrapper">
          <flip-countdown
            class="countdown"
            :labels="{
              days: '天',
              hours: '时',
              minutes: '分',
              seconds: '秒',
            }"
            :deadline="formatDate">
          </flip-countdown>
          <i class="el-icon-edit-outline" @click="editTarget"></i>
        </div>
      </template>
    </div>
    <div class="statistics">
      <el-tabs v-model="activeName" class="statistics-tabs">
        <el-tab-pane label="学习时长" name="time"></el-tab-pane>
        <el-tab-pane label="测试成绩" name="score"></el-tab-pane>
      </el-tabs>
      <div
        v-show="activeName === 'time'"
        class="chart"
        ref="time"></div>
      <div
        v-show="activeName === 'score'"
        class="chart"
        ref="score"></div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      class="target-dialog"
      ref="target-dialog">
      <div slot="title">目标</div>
      <div class="target-dialog-content">
        <div class="input-wrapper">
          <div class="input-title">写下自己的小目标并为此努力吧！</div>
          <el-form
            ref="target-form"
            :model="targetForm"
            :rules="{ title: [{ required: true, message: '还未填写自己的目标哦！', trigger: 'blur' },] }">
            <el-form-item prop="title">
              <input
                v-model="targetForm.title"
                type="text"
                placeholder="仅限输入15个字"
                maxlength="15" />
            </el-form-item>
          </el-form>
        </div>
        <div class="input-wrapper">
          <div class="input-title">给自己定一个期限用多长时间完成目标呢?</div>
        </div>
        <div class="input-wrapper">
          <el-date-picker
            v-model="time"
            :clearable="false"
            @change="onHandlerChange"
            :picker-options="pickerOptions"
            type="datetime"
            class="date-picker" />
        </div>
        <div class="btn-wrapper">
          <div
            class="btn btn-orange-square"
            @click="setTarget">完成</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  Tabs,
  TabPane,
  DatePicker,
  Form,
  FormItem,
} from 'element-ui';
import FlipCountdown from 'vue2-flip-countdown';
import ElDialog from '@/components/common/Dialog.vue';
import api from '@/api/index';
import utils from '@/services/utils';
import * as echarts from 'echarts';


export default {
  components: {
    ElTabs: Tabs,
    ElTabPane: TabPane,
    FlipCountdown,
    ElDialog,
    ElForm: Form,
    ElFormItem: FormItem,
    ElDatePicker: DatePicker,
  },
  props: {
    data: {
      type: Object,
      defatul: () => {},
    },
  },
  watch: {
    activeName() {
      if (this.activeName === 'time') {
        this.$nextTick(() => {
          this.renderTimeChart();
        });
      } else {
        this.$nextTick(() => {
          this.renderScoreChart();
        });
      }
    },
  },
  computed: {
    formatDate() {
      const time = new Date(JSON.parse(this.date));
      return utils.Date.format(time, 'yyyy/MM/dd HH:mm:ss');
    },
    isHasTarget() {
      return this.text && this.date;
    },
  },
  data() {
    return {
      activeName: 'time',
      time: '',
      text: this.data.target.title,
      date: this.data.target.time,
      pickerOptions: {
        disabledDate(time) {
          const day = 24 * 60 * 60 * 1000;
          return time.getTime() < Date.now() - day
            || time.getTime() > Date.now() + day * 365 * 5;
        },
      },
      targetForm: {
        title: this.data.target.title,
      },
    };
  },
  created() {
    if (this.data.target.time) {
      this.time = new Date(JSON.parse(this.data.target.time));
    }
  },
  mounted() {
    this.renderTimeChart();
  },
  methods: {
    renderTimeChart() {
      const chartDom = this.$refs.time;
      const myChart = echarts.init(chartDom);

      const option = {
        grid: {
          left: 40,
          top: 10,
          right: 30,
          bottom: 20,
        },
        tooltip: {
          formatter({ value }) {
            return `${value}分钟`;
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.data.learn_time_statistic.map(item => item.day),
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#eae7fd',
              width: 4,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#333654'],
              width: 1,
              type: 'solid',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#eae7fd',
              width: 4,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#333654'],
              width: 1,
              type: 'solid',
            },
          },
        },
        series: [{
          data: this.data.learn_time_statistic.map(item => item.time),
          type: 'line',
          symbol: 'image://https://vanthink.oss-cn-qingdao.aliyuncs.com/dd54b3be970ec19a425ef85d083e1495.png',
          symbolSize: 12,
          color: {
            type: 'radial',
          },
          areaStyle: {
            color: '#383768',
          },
          lineStyle: {
            width: 3,
            color: '#eae7fd',
          },
        }],
      };
      myChart.setOption(option);
    },
    renderScoreChart() {
      const chartDom = this.$refs.score;
      const myChart = echarts.init(chartDom);
      /* eslint-disable */

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              formatter: ({ seriesData }) => {
                const index = seriesData[0].dataIndex;;
                return `${this.data.examination_statistic[index].name}`;
              },
            },
          },
        },
        grid: {
          left: 40,
          top: 10,
          right: 30,
          bottom: 20,
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#eae7fd',
              width: 4,
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          data: this.data.examination_statistic.map(item => item.time),
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#333654'],
              width: 1,
              type: 'solid',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#eae7fd',
              width: 4,
            },
          },
        },
        series: [{
          data: this.data.examination_statistic.map(item => item.accuracy),
          type: 'bar',
          barWidth: '30%',
          itemStyle: {
            color: '#eae7fd',
          },
        }],
      };

      myChart.setOption(option);
    },
    setTarget() {
      this.$refs['target-form'].validate((valid) => {
        if (valid) {
          api.setTarget({
            title: this.targetForm.title,
            time: this.time,
          }).then(() => {
            utils.success('设置成功');
            this.text = this.targetForm.title;
            this.date = JSON.stringify(this.time);
            this.$refs['target-dialog'].close(); 
          });
        }
      });
    },
    editTarget() {
      this.$refs['target-dialog'].open(); 
    },
    onHandlerChange(value) {
      const time = new Date(value).getTime();
      const now = new Date().getTime();
      const limit = 60 * 1000 * 30;
      if (Math.abs(now - time) < 1000) {
        this.time = new Date(time + limit);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
  .sidebar-wrapper {
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .title {
      display: flex;
      justify-content: space-between;
      margin-top: 4.33vh;
      font-weight: 700;
      .left {
        font-size: 3.24vh;
        color: #FFFFFF;
      }
      .right {
        display: flex;
        align-items: center;
        padding: 0 1.5vh;
        color: #fff;
        font-size: 2.2vh;
        border: 1px solid $primary;
        border-radius: 16px;
        .icon {
          width: 1.8vh;
        }
        .integral {
          display: inline-block;
          margin: 0 4px 0 2px;
        }
      }
    }
    .name {
      margin-top: 10px;
      font-size: 3.24vh;
      font-weight: bold;
      color: #FFFFFF;
    }
    .card {
      position: relative;
      margin: 30px auto 10px;
      width: 100%;
      color: #fff;
      overflow: hidden;
      background: linear-gradient(to right bottom, #7928e0 , #492fb1);
      border-radius: 25px;
    }
    .sidebar-card {
      position: relative;
      margin: 30px auto 10px;
      width: 100%;
      height: 20vh;
      overflow: hidden;
      background: linear-gradient(to right bottom, #7928e0 , #492fb1);
      border-radius: 24px;
      .sidebar-card-logo-wrapper {
        display: inline-block;
        position: relative;
        left: 10%;
        top: 50%;
        transform: translateY(-50%);
        .round {
          height: 10vh;
          border-radius: 50%;
        }
        .ufo {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 7vh;
          border-radius: 50%;
        }
        .badge {
          position: absolute;
          left: 70%;
          top: 70%;
          width: 3vh;
        }
      }
      .school-info {
        position: absolute;
        top: 14%;
        right: 8%;
        display: inline-block;
        color: #fff;
        font-weight: 700;
        vertical-align: top;
        .school-name {
          font-size: 3vh;
        }
        .school-phone {
          display: flex;
          align-items: center;
          margin-top: 10px;
          font-size: 2.5vh;
          text-align: right;
          img {
            margin-right: -4px;
            width: 6vh;
          }
        }
      }
      .since {
        position: absolute;
        right: 8%;
        bottom: 12%;
        color: #fff;
        font-size: 2.3vh;
        font-weight: 700;
      }
    }
    .target-card {
      box-sizing: border-box;
      margin: 40px auto;
      padding: 0 20px;
      overflow: hidden;
      .no-target {
        margin: 20px 0;
        height: 15vh;
        border: 1px dashed #fff;
        border-radius: 15px;
        cursor: pointer;
        &:hover {
          opacity: .8;
        }
        .no-target-describe {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          font-size: 2.5vh;
          i {
            font-size: 3.5vh;
          }
          div {
            margin-top: 10px;
          }
        }
      }
      .target-card-title {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        font-size: 2.5vh;
        font-weight: 700;
        .right {
          font-size: 2vh;
        }
      }
      .describe {
        margin: 20px 0;
        font-size: 3vh;
        font-weight: 700;
      }
      .countdown-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .countdown {
          display: flex;
          margin: 0;
          /deep/ .flip-clock__piece {
            display: flex;
            align-items: center;
            .flip-card {
              font-size: 3vh;
            }
            .flip-clock__slot {
              margin-left: 4px;
            }
          }
        }
        .el-icon-edit-outline {
          font-size: 3vh;
          cursor: pointer;
        }
      }
    }
    .statistics {
      .statistics-tabs {
        width: 100%;
        color: red;
        /deep/ .el-tabs__header {
          width: 100%;
          .el-tabs__nav-wrap {
            width: 100%;
            &::after {
              background: transparent;
            }
            .el-tabs__nav-scroll {
              width: 100%;
              .el-tabs__nav  {
                width: 100%;
                .el-tabs__active-bar {
                  margin: 0 calc(25% - 8.33vh / 2);
                  width: 8.33vh!important;
                  height: 4px;
                  background-color: $primary;
                }
                .el-tabs__item.is-active {
                  color: #fff;
                }
                .el-tabs__item {
                  padding: 0;
                  width: 50%;
                  color: #fff;
                  font-size: 2.22vh;
                  text-align: center;
                  transition: transform .15s;
                  &:hover {
                    transform: scale(1.1);
                  }
                }
              }
            }
          }
        }
      }
      .chart {
        width: 100%;
        height: 20vh;
        min-height: 150px;
      }
    }
    .target-dialog {
      /deep/ .el-dialog {
        .target-dialog-content {
          .input-wrapper {
            .input-title {
              margin: 15px 0;
              color: $primary;
              font-size: 2.5vh;
              font-weight: 500;
            }
            input {
              box-sizing: border-box;
              width: 40%; 
              height: 5vh;
              border: 1px solid $primary;
              border-radius: 10px;
              &:focus-visible {
                outline: none;
              }
            }
            .el-form-item {
              input {
                padding-left: 10px;
              }
            }
            .date-picker {
              width: 60%;
            }
          }
          .btn-wrapper {
            position: relative;
            height: 10vh;
            .btn-orange-square {
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
    }
  }
</style>
